import { gql } from '@apollo/client';
import { RESOURCE_ROW_FRAGMENT } from './ResourceRowFragment';

const LIST_RESOURCES = gql`
  ${RESOURCE_ROW_FRAGMENT}

  query ListResources(
    $filter: ResourceArgsFilter!
    $sorter: ResourceArgsSorter
    $limit: Int
    $offset: Int
  ) {
    resources(
      filter: $filter
      sorter: $sorter
      limit: $limit
      offset: $offset
    ) {
      nodes {
        ...ResourceRowFragment
      }
      pageInfo {
        offset
        totalCount
      }
    }
  }
`;

export default LIST_RESOURCES;
